import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { DepartmentService } from '../proxy/planning/controllers/department.service';
import { LocalCorridorService } from '../proxy/planning/controllers/local-corridor.service';
import { PropertyService } from '../proxy/planning/controllers/property.service';

FieldBuilder.setNamespace('Planning');

export const LOADPROPERTY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('departmentId', 'Entity.Department', DepartmentService)
    .required()
    .displayFromNested('department.name')
    .sortBy('department.name')
    .build(),
  FieldBuilder
    .foreignKey('localCorridorId', 'Entity.LocalCorridor', LocalCorridorService)
    .displayFromNested('localCorridor.name')
    .sortBy('localCorridor.name')
    .build(),
  FieldBuilder
    .foreignKey('propertyId', 'Entity.Property', PropertyService)
    .required()
    .displayFromNested('property.name')
    .sortBy('property.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const LOADPROPERTY_CONFIG = {
  entityName: 'LoadProperty',
  localizationKey: 'Planning::Entity.LoadProperty',
  permission: 'GeneralLocations.LoadProperties',
  fields: LOADPROPERTY_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Locations + MENU_NAME_SUFFIX,
};
